import React from "react";

import { Images } from "../../config";

const QuestionnaireFileInput = (props) => {
  return (
    <div
      className="questionnaire-file-input"
      onClick={() => props?.photo && window.open(props?.photo, "_blank")}
    >
      <div
        className={`${
          props?.photo ? "opacity-[100%]" : "opacity-[50%]"
        } text-[14px]`}
      >
        {props?.photo ? "Download file" : "No File"}
      </div>
      <div>
        <img src={Images.QuestionnaireFileInput} className="h-[18px] pr-2" />
      </div>
    </div>
  );
};

export default QuestionnaireFileInput;
